<template>
  <div
    v-if="packages && packages.length > 0"
    class="you-may-also-like"
  >
    <ymal-header :content="content"/>
    <div class="row hidden-xs">
      <package-carousel :packages="packages"/>
    </div>
    <div class="row visible-xs">
      <package-listing :packages="packages"/>
    </div>
  </div>
</template>

<script>
import YmalHeader from './Header'
import PackageCarousel from './PackageCarousel'
import PackageListing from './PackageListing'

export default {
  name: 'YouMayAlsoLike',
  components: {
    YmalHeader,
    PackageCarousel,
    PackageListing
  },
  props: {
    selectedOfferPackageId: {
      type: Number,
      default: null
    },
    content: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      packages: null
    }
  },
  mounted () {
    this.$http
      .get(`${window.pageData.siteRoot}Catalog/GetRelatedPackages`, { params: { offerPackageId: this.selectedOfferPackageId } })
      .then((resp) => {
        this.packages = resp.data
      })
  }
}
</script>

<style lang="scss" scoped>
.you-may-also-like {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/YouMayAlsoLike/YouMayAlsoLike.vue